import { FC, memo } from 'react';

import { StatusBadge } from '../../../StatusBadge';
import { BlockState } from '../../constants/BlockState';
import { useBadge } from './hooks/useBadge';
import { BadgeProps } from './types/BadgeProps';

const BadgeComponent: FC<BadgeProps> = ({ block }) => {
  const { Icon } = useBadge(block);

  if (block.state === BlockState.Disabled) {
    return null;
  }

  return (
    <StatusBadge status={block.meta.status}>
      <Icon />
      {block.meta.label}
    </StatusBadge>
  );
};

export const Badge = memo(BadgeComponent);
